import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { Selbstbeteiligung, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { IAppState } from './appState';

export const INITIAL_STATE: IAppState = {
  version: 12,
  antragsnummer: null,
  vorbelegungen: {
    adresseImmobilieVorbelegt: false,
    immobilieVorbelegt: false,
    versicherungsnehmerVorbelegt: false,
    oeltankVorbelegt: false,
    activateElementar: false,
  },
  role: null,
  versicherungsnehmer: {
    geburtsdatum: '',
    isAssekuranztarif: false,
    juristisch: false,
  },
  risikoort: {
    plz: '',
    ort: '',
    strasse: '',
    hausnummer: '',
    land: {
      wert: '',
      text: '',
    },
    ortsteil: '',
    hausnrzus: '',
    status: null,
  },
  adressvorschlag: {
    orte: [],
    strassen: [],
    lastError: null,
  },
  gebaeude: {
    baujahr: null,
    wohnflaeche: null,
    nebengebaeude: {
      vorhanden: false,
      gesamtflaeche: null,
    },
  },
  merkmale: {
    keller: false,
    kellerMitWohnflaeche: null,
    holzhaus: false,
    dachbelag: false,
    flachdach: false,
    geothermie: false,
    solarthermie: false,
    photovoltaik: false,
    denkmalschutz: false,
    ferienhaus: false,
    nichtDauerhaftBewohnt: false,
    schwimmbad: false,
    de1kzdachbelag: false,
    feuerrohbau: null,
    gebkategorie: '',
    gebklasse: 'H',
  },
  vorschaeden: {
    vorhanden: null,
    feuerVorschaden: {
      count: 0,
      includeInDruck: true,
      includeInEinreichen: true,
      includeInTarifierung: true,
      visibleInErsatzgeschaeft: false,
    },
    leitungswasserVorschaden: {
      count: 0,
      includeInDruck: true,
      includeInEinreichen: true,
      includeInTarifierung: true,
      visibleInErsatzgeschaeft: false,
    },
    sturmhagelVorschaden: {
      count: 0,
      includeInDruck: true,
      includeInEinreichen: true,
      includeInTarifierung: true,
      visibleInErsatzgeschaeft: false,
    },
    elementarVorschaden: {
      count: 0,
      includeInDruck: true,
      includeInEinreichen: true,
      includeInTarifierung: true,
      visibleInErsatzgeschaeft: false,
    },
  },
  vertragsoptionen: {
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0000,
    zahlungsweise: Zahlweise.MONATLICH,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: true,
    isWeitererVertrag: false,
  },
  jahresbeitrag: 0,
  gesamtbeitrag: 0,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
  },
  produkt: null,
  gisDaten: null,
  elementarSelbstbehalt: {
    id: null,
    description: '',
  },
  vnWechselAngaben: {
    vnWechselGrundAngabenVorhanden: false,
    angabenListe: [],
    vnWechselgrundList: [],
  },
  transientState: {
    zurueckZumShopModalOpen: false,
    tarifierungIsInProgress: true,
    adressvorschlagIsInProgress: null,
    featureToggles: {},
    regexps: {},
    fehlerCodeTaas: '',
    priceGuarantee: false,
    role: null,
    vwgVorhandenError: null,
    vorvertragVorschaeden: null,
    mapViewModal: {
      isOpen: false,
      isAdresseTarifierbar: true,
      origin: null,
    },
    kooperationen: null,
    showZumAngebotLoadingSpinner: false,
  },
  rabattstufe: 0,
  hasVorversicherung: null,
  extremeWetterschutzSelbstbeteiligung: null,
  ueberschwemmungSelbstbeteiligung: null,
  erdbebenSelbstbetailigung: null,
};
